import { useEffect, useState } from "react";
import { navLinks } from "@/mocks/blog";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (id: string) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <header
      className={`fixed inset-x-0 top-0 z-40 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur shadow-[0_1px_0_oklch(var(--background-200))]"
          : "bg-transparent"
      }`}
    >
      <nav className="mx-auto flex h-16 w-full max-w-7xl items-center justify-between px-4 md:px-6">
        <button
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="flex cursor-pointer items-center gap-2 whitespace-nowrap"
          aria-label="吾爱吃瓜 首页"
        >
          <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
            <i className="ri-focus-3-line text-xl" aria-hidden="true"></i>
          </span>
          <span className="font-display text-xl font-bold tracking-wide text-foreground-950">
            吾爱<span className="text-primary-600">吃瓜</span>
          </span>
        </button>

        <div className="hidden items-center gap-7 lg:flex">
          {navLinks.map((link) => (
            <button
              key={link.id}
              onClick={() => scrollTo(link.id)}
              className="cursor-pointer whitespace-nowrap text-sm font-medium text-foreground-700 transition-colors hover:text-primary-600"
            >
              {link.label}
            </button>
          ))}
        </div>

        <div className="hidden items-center gap-3 lg:flex">
          <button
            onClick={() => scrollTo("subscribe")}
            className="whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            订阅更新
          </button>
        </div>

        <button
          onClick={() => setOpen(!open)}
          className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-md text-foreground-900 lg:hidden"
          aria-label={open ? "关闭菜单" : "打开菜单"}
        >
          <i className={`${open ? "ri-close-line" : "ri-menu-3-line"} text-2xl`} aria-hidden="true"></i>
        </button>
      </nav>

      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-4 pt-2 lg:hidden">
          {navLinks.map((link) => (
            <button
              key={link.id}
              onClick={() => scrollTo(link.id)}
              className="block w-full cursor-pointer rounded-md px-2 py-3 text-left text-base font-medium text-foreground-800 transition-colors hover:bg-background-100 hover:text-primary-600"
            >
              {link.label}
            </button>
          ))}
          <button
            onClick={() => scrollTo("subscribe")}
            className="mt-2 w-full cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-4 py-3 text-center text-base font-semibold text-background-50"
          >
            订阅更新
          </button>
        </div>
      )}
    </header>
  );
}